import { ICashSessionDTO, ICashSessionStatusKizReportDTO, ICashSessionViewDTO, IChequeKizReportDTO } from "../../coreapi-dto/accounting/cashSession";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { IRequestEventHandler } from "../common";
import { BaseDirRequest } from "../dirs/baseDirRequest";

class CashSessionRequest extends BaseDirRequest<ICashSessionViewDTO,ICashSessionDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler ){
        super(baseUrl,"cashSession",token,eventHandler)
    }

    closeSession(id: string, body: ICashSessionViewDTO,callback: (e) => void) {         
        
        this.post(`${this._baseUrl}/${this._routePrefix}`,body , this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), e => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        })
    }

    updateSession(idGlobal: string, body: ICashSessionDTO, callback: (e) => void) {
        this.post(`${this._baseUrl}/${this._routePrefix}`,body , this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), e => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        })
      }
    

    getCashSession(body: IViewBody, callback: (e) => void){
        this.post(`${this._baseUrl}/${this._routePrefix}/view`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), e => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }
    //Метод запроса статуса кизов кассовой смены:
    getChequesKizStatus(idGlobal: string, callback: (e) => void){
        this.patch(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/RequestChequesKizStatus`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), e => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }
    //Метод запроса отчета по статусам Киз:
    getChequesKizReport (body: ICashSessionStatusKizReportDTO, callback: (e) => void){
        this.post(`${this._baseUrl}/${this._routePrefix}/GetReport`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), e => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }
    //Метод получения информации из отчета и отправка схем по выбранным Киз:
    getSchemeToReport (body: IChequeKizReportDTO, callback: (e) => void){
        this.post(`${this._baseUrl}/${this._routePrefix}/SendSchemeToReport`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), e => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    getSumParameters(idGlobal: string, callback: (e) => void) {
    this.get(
      `${this._baseUrl}/${this._routePrefix}/GetSumParametersViewAsync/${idGlobal}`,
      this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
      (e) => {
        if (this._eventHandler) {
          if (e.respType === 'isFailed') {
            this._eventHandler.onGetResponse(e);
          }
        }
        callback(e);
      }
    );
  }

}

export default CashSessionRequest